import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false
		}
	}
	checkR25 = (e) => {
		//R25
		this.setState({ loading: true })
		fetch(window.location.origin + window.location.pathname + 'R25Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				var result = await response.text();
				if (result == "R26") {
					fetch(window.location.origin + window.location.pathname + 'R26Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
						this.setState({ loading: false })
						if (response.status == 200) {
							var PANumber = await response.text();
							if (PANumber) {
								this.props.setData('PANumber', PANumber)
								this.props.navigate("R28")
							} else {
								this.props.navigate("R26c")

							}
						} else {
							this.props.navigate("R26B")
						}
					})
				} else {
					this.setState({ loading: false })
					this.props.navigate(result)
				}
			} else {
				this.setState({ loading: false })
				this.setState({ HWError: "Unexpected Error has Occured" })
			}
		})
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Please note: The diagnosis code must be written on the script by the ordering provider. </p>

				<div className="button" onClick={() => this.checkR25()}>Continue</div>
			</div>
		);
	}
}